import { Box, Grid, Typography } from '@mui/material';
import { SubmitButton } from './SubmitButton';
import { useNavigate } from 'react-router';

export function AlreadyRegisteredPage(props: any) {
  const navigate = useNavigate();
  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={0} md={3} sm={2} />
          <Grid item xs={12} md={6} sm={8}>
            <Grid container direction={'column'} spacing={2}>
              <Grid item xs={12} mt={2} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <Typography mb={2} pt={2} fontSize={'16px'} className="font-bold">
                  登録エラー
                </Typography>
                <Typography mb={2} pt={2} fontSize={'14px'}>
                  お客様情報はすでに登録されています
                </Typography>
                <SubmitButton
                  label={'ログイン画面に戻る'}
                  onClick={() => {
                    window.location.reload();
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
